// 3D Box Loader — adapted from thanh/3d-box-loader-animation
import { motion } from 'framer-motion'

export default function LoadingScreen() {
  const loaderCss = `
    .callro-loader {
      --duration: 3s;
      --primary: #2563EB;
      --primary-light: #3B82F6;
      --primary-rgba: rgba(37, 99, 235, 0);
      width: 200px;
      height: 320px;
      position: relative;
      transform-style: preserve-3d;
    }

    @media (max-width: 480px) { .callro-loader { zoom: 0.54; } }

    .callro-loader:before, .callro-loader:after {
      --r: 20.5deg;
      content: "";
      width: 320px;
      height: 140px;
      position: absolute;
      right: 32%;
      bottom: -11px;
      background: #111113;
      transform: translateZ(200px) rotate(var(--r));
      animation: callro-mask var(--duration) linear forwards infinite;
    }
    .callro-loader:after { --r: -20.5deg; right: auto; left: 32%; }

    .callro-loader .cl-ground {
      position: absolute;
      left: -50px;
      bottom: -120px;
      transform-style: preserve-3d;
      transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
    }
    .callro-loader .cl-ground div {
      transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);
      width: 200px;
      height: 200px;
      background: var(--primary);
      background: linear-gradient(45deg, var(--primary) 0%, var(--primary) 50%, var(--primary-light) 50%, var(--primary-light) 100%);
      transform-style: preserve-3d;
      animation: callro-ground var(--duration) linear forwards infinite;
    }
    .callro-loader .cl-ground div:before,
    .callro-loader .cl-ground div:after {
      --rx: 90deg; --ry: 0deg; --x: 44px; --y: 162px; --z: -50px;
      content: "";
      width: 156px;
      height: 300px;
      opacity: 0;
      background: linear-gradient(var(--primary), var(--primary-rgba));
      position: absolute;
      transform: rotateX(var(--rx)) rotateY(var(--ry)) translate(var(--x), var(--y)) translateZ(var(--z));
      animation: callro-ground-shine var(--duration) linear forwards infinite;
    }
    .callro-loader .cl-ground div:after { --rx: 90deg; --ry: 90deg; --x: 0; --y: 177px; --z: 150px; }

    .callro-loader .cl-box {
      --x: 0; --y: 0;
      position: absolute;
      animation: var(--duration) linear forwards infinite;
      transform: translate(var(--x), var(--y));
    }
    .callro-loader .cl-box div {
      background-color: var(--primary);
      width: 48px;
      height: 48px;
      position: relative;
      transform-style: preserve-3d;
      animation: var(--duration) ease forwards infinite;
      transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
    }
    .callro-loader .cl-box div:before,
    .callro-loader .cl-box div:after {
      --rx: 90deg; --ry: 0deg; --z: 24px; --y: -24px; --x: 0;
      content: "";
      position: absolute;
      background-color: inherit;
      width: inherit;
      height: inherit;
      transform: rotateX(var(--rx)) rotateY(var(--ry)) translate(var(--x), var(--y)) translateZ(var(--z));
      filter: brightness(var(--b, 1.2));
    }
    .callro-loader .cl-box div:after { --rx: 0deg; --ry: 90deg; --x: 24px; --y: 0; --b: 1.4; }

    .callro-loader .cl-box.b0 { --x: -220px; --y: -120px; left: 58px; top: 108px; animation-name: cl-move0; }
    .callro-loader .cl-box.b1 { --x: -260px; --y: 120px;  left: 25px; top: 120px; animation-name: cl-move1; }
    .callro-loader .cl-box.b2 { --x: 120px;  --y: -190px; left: 58px; top: 64px;  animation-name: cl-move2; }
    .callro-loader .cl-box.b3 { --x: 280px;  --y: -40px;  left: 91px; top: 120px; animation-name: cl-move3; }
    .callro-loader .cl-box.b4 { --x: 60px;   --y: 200px;  left: 58px; top: 132px; animation-name: cl-move4; }
    .callro-loader .cl-box.b5 { --x: -220px; --y: -120px; left: 25px; top: 76px;  animation-name: cl-move5; }
    .callro-loader .cl-box.b6 { --x: -260px; --y: 120px;  left: 91px; top: 76px;  animation-name: cl-move6; }
    .callro-loader .cl-box.b7 { --x: -240px; --y: 200px;  left: 58px; top: 87px;  animation-name: cl-move7; }

    .callro-loader .cl-box.b0 div { animation-name: cl-scale0; }
    .callro-loader .cl-box.b1 div { animation-name: cl-scale1; }
    .callro-loader .cl-box.b2 div { animation-name: cl-scale2; }
    .callro-loader .cl-box.b3 div { animation-name: cl-scale3; }
    .callro-loader .cl-box.b4 div { animation-name: cl-scale4; }
    .callro-loader .cl-box.b5 div { animation-name: cl-scale5; }
    .callro-loader .cl-box.b6 div { animation-name: cl-scale6; }
    .callro-loader .cl-box.b7 div { animation-name: cl-scale7; }

    @keyframes cl-move0 { 12% { transform: translate(var(--x), var(--y)); } 25%, 52% { transform: translate(0,0); } 80% { transform: translate(0,-32px); } 90%, 100% { transform: translate(0,188px); } }
    @keyframes cl-scale0 { 6%  { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0); } 14%, 100% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1); } }
    @keyframes cl-move1 { 16% { transform: translate(var(--x), var(--y)); } 29%, 52% { transform: translate(0,0); } 80% { transform: translate(0,-32px); } 90%, 100% { transform: translate(0,188px); } }
    @keyframes cl-scale1 { 10% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0); } 18%, 100% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1); } }
    @keyframes cl-move2 { 20% { transform: translate(var(--x), var(--y)); } 33%, 52% { transform: translate(0,0); } 80% { transform: translate(0,-32px); } 90%, 100% { transform: translate(0,188px); } }
    @keyframes cl-scale2 { 14% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0); } 22%, 100% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1); } }
    @keyframes cl-move3 { 24% { transform: translate(var(--x), var(--y)); } 37%, 52% { transform: translate(0,0); } 80% { transform: translate(0,-32px); } 90%, 100% { transform: translate(0,188px); } }
    @keyframes cl-scale3 { 18% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0); } 26%, 100% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1); } }
    @keyframes cl-move4 { 28% { transform: translate(var(--x), var(--y)); } 41%, 52% { transform: translate(0,0); } 80% { transform: translate(0,-32px); } 90%, 100% { transform: translate(0,188px); } }
    @keyframes cl-scale4 { 22% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0); } 30%, 100% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1); } }
    @keyframes cl-move5 { 32% { transform: translate(var(--x), var(--y)); } 45%, 52% { transform: translate(0,0); } 80% { transform: translate(0,-32px); } 90%, 100% { transform: translate(0,188px); } }
    @keyframes cl-scale5 { 26% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0); } 34%, 100% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1); } }
    @keyframes cl-move6 { 36% { transform: translate(var(--x), var(--y)); } 49%, 52% { transform: translate(0,0); } 80% { transform: translate(0,-32px); } 90%, 100% { transform: translate(0,188px); } }
    @keyframes cl-scale6 { 30% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0); } 38%, 100% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1); } }
    @keyframes cl-move7 { 40% { transform: translate(var(--x), var(--y)); } 53%, 52% { transform: translate(0,0); } 80% { transform: translate(0,-32px); } 90%, 100% { transform: translate(0,188px); } }
    @keyframes cl-scale7 { 34% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0); } 42%, 100% { transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1); } }

    @keyframes callro-ground {
      0%, 65%  { transform: rotateX(90deg) rotateY(0deg) translate(-48px,-120px) translateZ(100px) scale(0); }
      75%, 90% { transform: rotateX(90deg) rotateY(0deg) translate(-48px,-120px) translateZ(100px) scale(1); }
      100%     { transform: rotateX(90deg) rotateY(0deg) translate(-48px,-120px) translateZ(100px) scale(0); }
    }
    @keyframes callro-ground-shine {
      0%, 70%    { opacity: 0;   }
      75%, 87%   { opacity: 0.3; }
      100%       { opacity: 0;   }
    }
    @keyframes callro-mask {
      0%, 65% { opacity: 0; }
      66%, 100% { opacity: 1; }
    }

    .callro-loading-wordmark {
      font-family: var(--font-display);
      font-size: 1.125rem;
      font-weight: 700;
      color: var(--text-secondary);
      letter-spacing: 0.15em;
      text-transform: uppercase;
      animation: callro-fade-pulse 2s ease-in-out infinite;
    }
    @keyframes callro-fade-pulse {
      0%, 100% { opacity: 0.5; }
      50%      { opacity: 1;   }
    }
  `

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, filter: 'blur(10px)' }}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--bg-base)',
        flexDirection: 'column',
        gap: '2.5rem',
      }}
    >
      <style>{loaderCss}</style>

      {/* 3D Box Loader */}
      <div className="callro-loader">
        {[0,1,2,3,4,5,6,7].map(i => (
          <div key={i} className={`cl-box b${i}`}><div /></div>
        ))}
        <div className="cl-ground"><div /></div>
      </div>

      {/* Wordmark */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.375rem' }}>
        <span className="callro-loading-wordmark">Callro</span>
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.6875rem', color: 'var(--text-muted)', letterSpacing: '0.05em' }}>
          Loading command centre...
        </span>
      </div>
    </motion.div>
  )
}
